import { render, staticRenderFns } from "./elPagination.vue?vue&type=template&id=1c28d89d&scoped=true&"
import script from "./elPagination.vue?vue&type=script&lang=js&"
export * from "./elPagination.vue?vue&type=script&lang=js&"
import style0 from "./elPagination.vue?vue&type=style&index=0&id=1c28d89d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c28d89d",
  null
  
)

export default component.exports